const drawerCart = document.getElementById("drawerCart");
const openCartBtn = document.querySelector(".openCartBtn");
const closeCartBtn = document.querySelector(".closeCartBtn");

// 初期設定：閉じるボタンは非表示
closeCartBtn.style.display = "none";

// "カートを表示"ボタンがクリックされた時の処理
openCartBtn.addEventListener("click", () => {
    drawerCart.style.display = "block"; // カートを表示
    openCartBtn.style.display = "none"; // 表示ボタンを非表示
    closeCartBtn.style.display = "block"; // 閉じるボタンを表示
});

// "✕ 閉じる"ボタンがクリックされた時の処理
closeCartBtn.addEventListener("click", () => {
    drawerCart.style.display = "none"; // カートを非表示
    closeCartBtn.style.display = "none"; // 閉じるボタンを非表示
    openCartBtn.style.display = "block"; // 表示ボタンを再表示
});

function scrollToTop() {
    window.scrollTo({
      top: 500,
      behavior: 'smooth' // スムーズにスクロール
    });
  }

// ページ内のすべての <img> 要素にクリックイベントを追加
document.querySelectorAll('img').forEach((img) => {
  img.addEventListener('click', function () {
    // class="ponpon-modal-wrapper" の要素を取得
    const targetElement = document.querySelector('.ponpon-modal-wrapper');
    
    // 要素が存在する場合にスクロールを実行
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // スムーズスクロール
        block: 'start',     // 要素を画面上部に表示
      });
    }
  });
});
